import * as S from './styles';
import { Select, type SelectProps } from 'antd';
import React, { FC } from 'react';
import { IShop } from '@types';
import { authInfoSelect, handleSwitchShop } from '@entities/auth';
import { clearBookingState } from '@entities/booking';
import { clearAllCardState } from '@entities/card';
import { clearClientState } from '@entities/client';
import { clearLogsState } from '@entities/logs';
import { clearNotifyState } from '@entities/notify';
import { clearReportsState } from '@entities/reports';
import { clearRkepeerState } from '@entities/rKeeper';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '@config/store';
import { useNavigate } from 'react-router-dom';

export const SwitchShops: FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { shop, shops } = useSelector(authInfoSelect);

    const options: SelectProps['options'] =
        shops?.map((item: IShop) => ({
            label: item.name,
            value: item.id.toString(),
        })) || [];

    const handleSelectClick = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    const handleChange = (value: string) => {
        if (shop && shop.id !== +value) {
            const selectedShop = shops.find(shop => shop.id === +value);
            if (!selectedShop) return;
            navigate(selectedShop.role.route);
            dispatch(handleSwitchShop({ id: +value }));
            dispatch(clearBookingState());
            dispatch(clearAllCardState());
            dispatch(clearClientState());
            dispatch(clearLogsState());
            dispatch(clearNotifyState());
            dispatch(clearReportsState());
            dispatch(clearRkepeerState());
        }
    };

    return (
        <S.WrapSelect>
            <span>Выбрать заведение</span>
            <Select
                defaultValue={shop?.id?.toString()}
                style={{
                    width: '100%',
                    zIndex: 9999,
                }}
                placeholder="Выбрать заведение"
                onChange={handleChange}
                options={options}
                onClick={handleSelectClick}
                dropdownRender={menu => (
                    <div onClick={handleSelectClick}>{menu}</div>
                )}
            />
        </S.WrapSelect>
    );
};
